/*
 * Copyright (c) 2025 AirAsia Berhad (Malaysia). All rights reserved.
 *
 * This software is proprietary and confidential. Unauthorized copying of this file,
 * via any medium, is strictly prohibited. Do not distribute, copy, modify, or reuse
 * any part of this code without explicit written permission from AirAsia Move.
 *
 * For internal use only.
 */

import { pd } from '@airasia-phoenix/react-native/tokens';
import { getColor } from '@airasia-phoenix/react-native/utils/utils';
import { StyleSheet } from 'react-native-unistyles';
import { WEB_CONTENT_WIDTHS } from '../../utils/layout';

const styles = StyleSheet.create((pd) => ({
  container: {
    backgroundColor: getColor(pd.sys.colour.container_low),
    width: '100%',
    paddingVertical: pd.ref.space.spacing30.px,
  },
  content: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    marginHorizontal: 'auto',
    flex: 1,
    width: WEB_CONTENT_WIDTHS,
    maxWidth: WEB_CONTENT_WIDTHS,
    paddingHorizontal: pd.ref.space.spacing40.px,
    justifyContent: 'space-between',
    alignSelf: 'center',
  },
  mainText: {
    flex: 1,
    flexWrap: 'wrap',
    maxWidth: `calc(100% - 50px)` as any,
  },
}));

export default styles;
